import * as React from "react"
import { CornerDownLeft } from "lucide-react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const kbdVariants = cva(
  "pointer-events-none hidden w-fit select-none items-center justify-center gap-0.5 font-sans font-medium md:inline-flex [&_svg:not([class*='size-'])]:size-2.5 [[data-slot=tooltip-content]_&]:bg-background/20 [[data-slot=tooltip-content]_&]:text-background dark:[[data-slot=tooltip-content]_&]:bg-background/10",
  {
    variants: {
      variant: {
        chip:
          "h-4 min-w-0 rounded px-1 text-[10px] leading-none bg-muted/80 text-muted-foreground border border-border/50",
        inline:
          "h-auto min-w-0 bg-transparent px-0 text-[10px] leading-none font-normal text-current opacity-55",
      },
    },
    defaultVariants: {
      variant: "chip",
    },
  }
)

export function formatPrimaryShortcutLabel(isMac: boolean): string {
  return isMac ? "⌘↵" : "Ctrl+↵"
}

type KbdProps = React.ComponentProps<"kbd"> & VariantProps<typeof kbdVariants>

function Kbd({ className, variant, ...props }: KbdProps) {
  return (
    <kbd
      data-slot="kbd"
      className={cn(kbdVariants({ variant }), className)}
      {...props}
    />
  )
}

function KbdGroup({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="kbd-group"
      className={cn("hidden items-center gap-0.5 md:inline-flex", className)}
      {...props}
    />
  )
}

function KbdEnter({ className, variant, ...props }: KbdProps) {
  return (
    <Kbd className={cn(className)} variant={variant} {...props}>
      <CornerDownLeft aria-hidden />
    </Kbd>
  )
}

export { Kbd, KbdGroup, KbdEnter, kbdVariants }
